import { createContext, useContext, useEffect, useState } from 'react';
import { fetchProductsPage, fetchRackingSystems } from '../services/api';

const ProductsContext = createContext(null);

async function loadProductsData() {
  const [page, nav] = await Promise.all([fetchProductsPage(), fetchRackingSystems()]);
  return { page, nav };
}

export function ProductsProvider({ children }) {
  const [pageData, setPageData] = useState(null);
  const [navProducts, setNavProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async (attempt = 0) => {
      try {
        const { page, nav } = await loadProductsData();
        if (cancelled) return;
        setPageData(page);
        setNavProducts(nav);
        setError(null);
        setLoading(false);
      } catch (e) {
        if (cancelled) return;
        if (attempt < 2) {
          setTimeout(() => load(attempt + 1), 1500);
          return;
        }
        setError(
          e.message === 'Failed to fetch'
            ? 'Cannot reach the API. Start the backend with: cd backend && npm run dev'
            : e.message
        );
        setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ProductsContext.Provider value={{ pageData, navProducts, loading, error }}>
      {children}
    </ProductsContext.Provider>
  );
}

export function useProducts() {
  const ctx = useContext(ProductsContext);
  if (!ctx) throw new Error('useProducts must be used within ProductsProvider');
  return ctx;
}

export function getProductFromPage(pageData, slug) {
  return pageData?.products?.find((p) => p.id === slug) || null;
}
